import React from 'react'
import { FoodPreset } from 'services/api/entities/catalog/packages/foodPackage'
import { ProductPresetField } from '../ProductPresetField'
import { OnlyWithPresetsOrId } from '../eventPackage/package/common'
import OptionGroupWithItems from 'ui-shared/OptionGroupItems'
import { Box, Container } from '@mui/material'
import LocalizedSpan from 'ui-shared/LocalizedFields/LocalizedSpan'

type Props = {
  pkg?: OnlyWithPresetsOrId<FoodPreset>
}

const FoodPackageReadonlyPresetsList: React.FC<Props> = ({ pkg }) => {
  return (
    <Container>
      <Box display="flex" flexDirection="column">
        {pkg &&
          typeof pkg !== 'number' &&
          pkg.presets.map((preset, index) => (
            <React.Fragment key={preset.id}>
              <h3>{`${index + 1}) \n`}Presets</h3>
              <ProductPresetField record={preset} />
              {preset.optionsFull.map((option, index) => (
                <OptionGroupWithItems
                  key={`food_${option.id}`}
                  option={option}
                  index={index}
                />
              ))}

              {preset.upselling?.map((upselling, index) => (
                <Box marginLeft="1.5rem" key={`food_${upselling.id}`}>
                  <h4>{`${index + 1}) \n`}Upselling </h4>
                  <ProductPresetField record={upselling} hasRatioMultiplier />
                </Box>
              ))}

              {!!preset.logisticFull && (
                <Box
                  display="flex"
                  justifyContent="flex-start"
                  alignItems="center"
                  style={{ gap: '1rem', fontSize: '1.2rem' }}
                  marginLeft="1.5rem"
                >
                  <h5>Logistics: </h5>
                  <LocalizedSpan style={{ marginRight: '1.5rem' }}>
                    {preset.logisticFull.name}
                  </LocalizedSpan>

                  <h5>Delivery Time Logic: </h5>
                  <span>{preset.deliveryTimeLogic}</span>
                </Box>
              )}
            </React.Fragment>
          ))}
      </Box>
    </Container>
  )
}

export default FoodPackageReadonlyPresetsList
